import React from "react";
import {encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';

import { Helpers } from "../../config/Helpers";

class List extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            search: '',
            loading: true,
            storeData: [],
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getWarung();
        }
    }

    getWarung = () => {
        this.setState({ loading: true });

        Helpers.getWarung('', this.state.sessUserCode).then(res => {
            this.setState({
                storeData: (res) ? res : [],
                loading: false
            });
        })
    };

    getFiltered = () => {
        if(!this.state.search){
            return this.state.storeData;
        }

        const str = this.state.search.toUpperCase();
        const searchableKeys = ["KodeWarung", "NamaWarung"];

        return this.state.storeData.filter((item) => {
            return searchableKeys.some((key) => ((item[key]) ? item[key] : '').toString().toUpperCase().includes(str));
        });
    };

    handleSearch = (e) => {
        e.preventDefault();
        this.setState({ search: this.state.search });
    };

    handleStoreClick = (object) => {
        window.location.href = './store-manage?trxid=' + base64_encode(object.KodeWarung) + '&action=update';
    };

    render() {
        const filtered = this.getFiltered();

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Mitra</h1>
                    </div>

                    <div className="location-search-row">
                        <form method="post" onSubmit={(e) => {this.handleSearch(e)}}>
                            <i className="fi-rs-search location-search-icon"></i>
                            <input type="text" placeholder="Cari mitra" value={this.state.search} onChange={e => this.setState({search: e.target.value})}/>
                            {
                                this.state.search && (
                                    <i className="fi-rs-cross-circle location-search-clear" onClick={() => this.setState({search: ''})}></i>
                                )
                            }
                        </form>
                        <a href={'./store-manage?trxid=&action=insert'} className="location-add-btn">
                            <i className="fi-rs-plus"></i> Tambah
                        </a>
                    </div>

                    <div className="detail-wrap">
                        {
                            this.state.loading ? (
                                <div className="detail-card">
                                    <div className="detail-card-head">
                                        <span className="detail-card-accent"></span>
                                        <span className="detail-card-title">Memuat data...</span>
                                    </div>
                                </div>
                            ) : filtered.length > 0 ? (
                                filtered.map((object, i) => (
                                    <div className="partner-card" key={i} onClick={() => {this.handleStoreClick(object)}}>
                                        <div className="partner-card-top">
                                            <div>
                                                <div className="partner-card-code">{object.KodeWarung}</div>
                                                <div className="partner-card-date">{object.date_d} {object.date_m} {object.date_y}</div>
                                            </div>
                                            {
                                                object.NamaPemilikWarung && (
                                                    <span className="partner-card-badge">{object.NamaPemilikWarung}</span>
                                                )
                                            }
                                        </div>

                                        <div className="partner-card-divider"></div>

                                        <div className="partner-card-body">
                                            {
                                                object.FotoWarung ? (
                                                    <img className="partner-card-thumb" src={'https://waroq.com/WRQSVC/image/FotoWarung/' + object.FotoWarung} alt=""/>
                                                ) : (
                                                    <div className="partner-card-thumb partner-card-thumb-icon">
                                                        <i className="fi-rs-shop"></i>
                                                    </div>
                                                )
                                            }
                                            <div className="partner-card-info">
                                                <div className="partner-card-name">{object.NamaWarung}</div>
                                                <div className="partner-card-address">{object.Alamat}</div>
                                            </div>
                                            <i className="fi-rs-angle-small-right partner-card-chevron"></i>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="order-empty">
                                    <i className="fi-rs-shop"></i>
                                    <p>Belum ada mitra terdaftar</p>
                                </div>
                            )
                        }
                    </div>
                </main>
            </>
        );
    }
}

export default List;
